/** Wire values for CRUD filters, table selects, and query params (`eq:true` / `eq:false`). */
export const BOOLEAN_STRING = {
  True: 'true',
  False: 'false',
} as const;

export type BooleanString =
  (typeof BOOLEAN_STRING)[keyof typeof BOOLEAN_STRING];

export const isBooleanStringTrue = (value: unknown): boolean =>
  String(value) === BOOLEAN_STRING.True;

export const isBooleanStringFalse = (value: unknown): boolean =>
  String(value) === BOOLEAN_STRING.False;
